import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Button,
  LoadingIndicator,
  Select
} from "../../../../components/simple";
import XandrForm from "../../../../components/forms/XandrForm";
import Api from "../../../../api";
import usePrevious from "../../../../hooks/usePrev";

import { PLATFORMS } from "../platforms";

import styles from "../push-modal.module.scss";
import main from "./styles.module.scss";
import LabelForRow from "../../../../components/forms/LabelForRow";

const Xandr = ({
  selectedPlatform,
  // audienceType,
  handlePushToPlatform,
  // editAudienceHandler,
  // onDownload,
  onDownloadZip
  // allowEdit
}) => {
  const [xandrIsAuthorized, setXandrIsAuthorized] = useState(false);
  const [xandrIsShowAuth, handleOpenAuthXandr] = useState(false);
  const [errorXandr, clearErroXandr] = useState("");

  const [selectedData, setSelectedData] = useState({
    advertisersId: "",
    lineItemsId: ""
  });

  const [responseData, setResponseData] = useState({
    advertisers: [],
    lineItems: []
  });

  const [responseErrorMessage, setResponseErrorMessage] = useState({
    advertisers: "",
    lineItems: ""
  });

  const prevSelectedData = usePrevious(selectedData);
  const platforms = useSelector(state => state.platforms);

  const getAdvertisers = async () => {
    if (!xandrIsAuthorized) return;
    try {
      const advertisersResponse = await Api.platforms.xandr.getAdvertisers();
      if (advertisersResponse.message) {
        setResponseErrorMessage(prevState => ({
          ...prevState,
          advertisers: advertisersResponse.message
        }));

        setResponseData({
          advertisers: [],
          lineItems: []
        });
        return;
      }

      setResponseData({
        advertisers: advertisersResponse,
        lineItems: []
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const checkXandrIsAuthorized = async () => {
      await Api.platforms.xandr
        .isAuthorized()
        .then(res => {
          if (res?.valid) {
            setXandrIsAuthorized(true);
          } else {
            setXandrIsAuthorized(false);
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    checkXandrIsAuthorized();
    getAdvertisers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      if (selectedPlatform === PLATFORMS.xandr) {
        handleOpenAuthXandr(false);
      }
    };
  }, [selectedPlatform]);

  useEffect(() => {
    if (!xandrIsAuthorized || selectedPlatform !== PLATFORMS.xandr) return;

    const getLineItems = async advertisersId => {
      setSelectedData(prevData => ({
        ...prevData,
        lineItemsId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        lineItems: ""
      }));

      try {
        const lineItemsResponse = await Api.platforms.xandr.getLineItems({
          advertiser_id: advertisersId
        });

        if (lineItemsResponse.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            lineItems: lineItemsResponse.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            advertisers: [],
            lineItems: []
          }));

          return;
        }
        setResponseData(prevData => ({
          ...prevData,
          lineItems: lineItemsResponse
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (!responseData.advertisers.length) getAdvertisers();

    if (
      prevSelectedData.advertisersId !== selectedData.advertisersId &&
      selectedData.advertisersId
    ) {
      getLineItems(selectedData.advertisersId);
    }
    // eslint-disable-next-line
  }, [
    xandrIsAuthorized,
    selectedData,
    responseData,
    prevSelectedData,
    responseErrorMessage,
    selectedPlatform
  ]);

  const handleSelectChange = (name, value) => {
    setSelectedData(prevData => ({
      ...prevData,
      [`${name}Id`]: value
    }));
  };

  const handleAuth = async ({ username, password }) => {
    try {
      const authorize = await Api.platforms.xandr.auth({
        data: { username, password }
      });
      if (authorize === true) {
        setXandrIsAuthorized(true);
        clearErroXandr("");
      } else {
        clearErroXandr(authorize);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitHandler = e => {
    e.preventDefault();
    if (selectedData.lineItemsId)
      handlePushToPlatform(PLATFORMS.xandr, {
        lineItemsId: selectedData.lineItemsId
      });
  };
  // <SVG.Close className="close-modal" onClick={handleClose} />

  return (
    <>
      <div
        style={{ width: "100%" }}
        className={` ${styles["fb-signin"]} ${
          selectedPlatform === PLATFORMS.xandr ? styles["slide-from-right"] : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <img src={SVG.Xandr} className={main["platform-icon"]} alt="xandr" /> */}
        {/*  Xandr */}
        {/* </div> */}
        {xandrIsAuthorized ? (
          <div className={main.form}>
            <form onSubmit={onSubmitHandler}>
              {!responseErrorMessage.advertisers ? (
                <div>
                  <LabelForRow
                    label="Choose the advertiser you want to activate on"
                    title="Pick Advertiser"
                  />
                  <Select
                    value={
                      selectedData.adAccountId
                        ? {
                            label: "adAccount",
                            value: selectedData.adAccountId
                          }
                        : ""
                    }
                    isSearchable
                    selectForThePushForm
                    label="Advertiser"
                    placeholder="Advertiser"
                    optionLabel="name"
                    optionValue="id"
                    options={responseData.advertisers}
                    name="advertisers"
                    handleChange={handleSelectChange}
                    isDisabled={!responseData.advertisers.length}
                    required
                  />
                </div>
              ) : (
                <p
                  className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                >
                  {responseErrorMessage.advertisers}
                </p>
              )}

              {!responseErrorMessage.lineItems ? (
                <div>
                  <LabelForRow
                    label="Choose the adset the audience needs to be added to"
                    title="Pick Line Item"
                  />
                  <Select
                    isSearchable
                    selectForThePushForm
                    label="Line item"
                    placeholder="Line item"
                    optionLabel="name"
                    optionValue="id"
                    options={responseData.lineItems}
                    name="lineItems"
                    handleChange={handleSelectChange}
                    isDisabled={!responseData.lineItems.length}
                    required
                  />
                </div>
              ) : (
                <p
                  className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                >
                  {responseErrorMessage.lineItems}
                </p>
              )}

              {platforms?.isLoading ? (
                <div
                  style={{ marginTop: "32px" }}
                  className="mt-4 d-flex justify-content-center"
                >
                  <LoadingIndicator />
                </div>
              ) : (
                <>
                  <div className={styles.button_container}>
                    <Button
                      disabled={!selectedData.lineItemsId}
                      type="submit"
                      className={styles["push-audience-btn"]}
                    >
                      <span>Push</span>
                    </Button>
                    {/* {audienceType === "audience" && allowEdit && ( */}
                    {/*  <Button */}
                    {/*    type="button" */}
                    {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
                    {/*    onClick={editAudienceHandler} */}
                    {/*  > */}
                    {/*    <span>Edit audience</span> */}
                    {/*  </Button> */}
                    {/* )} */}
                  </div>
                  {/* <div className={main["dwn-csv-wrapper"]}> */}
                  {/*  <p>OR</p> */}
                  {/*  <h5 className={main.title}> */}
                  {/*    Download CSV for Geo Radius Segments */}
                  {/*  </h5> */}
                  {/*  <Button */}
                  {/*    type="button" */}
                  {/*    className={styles["platform-signin-button"]} */}
                  {/*    style={{ */}
                  {/*      width: 195, */}
                  {/*      textTransform: "uppercase", */}
                  {/*      margin: "10px 0" */}
                  {/*    }} */}
                  {/*    onClick={() => { */}
                  {/*      onDownload(); */}
                  {/*    }} */}
                  {/*  > */}
                  {/*    Download CSV */}
                  {/*  </Button> */}
                  {/* </div> */}
                </>
              )}
            </form>
          </div>
        ) : (
          <>
            {xandrIsShowAuth ? (
              <XandrForm
                handleSubmit={handleAuth}
                handleZIP={onDownloadZip}
                className={main.form}
                error={errorXandr}
              />
            ) : (
              <>
                <div className={styles["connect-account"]}>Connect Account</div>
                <Button
                  className={styles["platform-signin-button"]}
                  onClick={() => handleOpenAuthXandr(true)}
                >
                  Sign in to Xandr
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

Xandr.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  selectedPlatform: PropTypes.string,
  handlePushToPlatform: PropTypes.func,
  // onDownload: PropTypes.func,
  onDownloadZip: PropTypes.func

  // editAudienceHandler: PropTypes.func.isRequired,
  // allowEdit: PropTypes.bool.isRequired
};

Xandr.defaultProps = {
  selectedPlatform: "",
  handlePushToPlatform: () => {},
  // onDownload: () => {},
  onDownloadZip: () => {}
};

export default Xandr;
